import React, { useEffect, useState } from 'react';
import api from '../services/api';

// ── Vista admin: resumen de todos los cobradores ──────────────────────────────
const VistaAdmin: React.FC = () => {
  const [datos, setDatos] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
  const [expandido, setExpandido] = useState<string | null>(null);

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/caja/resumen-dia?fecha=${fecha}`);
      setDatos(res.data);
    } catch {}
    finally { setLoading(false); }
  };

  useEffect(() => { cargar(); }, [fecha]); // eslint-disable-line

  const totalGeneral = datos.reduce((acc, d) => acc + (d.totalSistema || 0), 0);
  const totalGastos = datos.reduce((acc, d) => acc + (d.totalGastos || 0), 0);
  const cerrados = datos.filter(d => d.arqueo).length;
  const conDiferencia = datos.filter(d => d.arqueo && Math.abs(Number(d.arqueo.diferencia)) >= 0.01).length;

  const chipDif = (dif: number) => {
    const ok = Math.abs(dif) < 0.01;
    const color = ok ? '#22c55e' : dif > 0 ? '#f59e0b' : '#ef4444';
    const label = ok ? '✓ Cuadrado' : dif > 0 ? `+S/. ${dif.toFixed(2)} sobrante` : `-S/. ${Math.abs(dif).toFixed(2)} faltante`;
    return (
      <span style={{ fontSize:11, fontWeight:700, color, background:color+'22', border:`1px solid ${color}`, borderRadius:20, padding:'2px 8px' }}>
        {label}
      </span>
    );
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h2 style={{ color:'#f1f5f9', margin:0, fontSize:24, fontWeight:800 }}>🏦 Caja / Arqueo Diario</h2>
          <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>Seguimiento de recaudacion y cierre de caja por cobrador</p>
        </div>
        <input type="date" value={fecha} onChange={e => setFecha(e.target.value)}
          style={{ background:'#1e293b', border:'1px solid #334155', color:'#f1f5f9', padding:'8px 12px', borderRadius:8, fontSize:14 }} />
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:16, marginBottom:24 }}>
        {[
          { label:'Total recaudado', value:`S/. ${totalGeneral.toFixed(2)}`, color:'#22c55e' },
          { label:'Total gastos', value:`S/. ${totalGastos.toFixed(2)}`, color:'#f59e0b' },
          { label:'Cobradores cerrados', value:`${cerrados} / ${datos.length}`, color:'#38bdf8' },
          { label:'Con diferencia', value:conDiferencia.toString(), color:conDiferencia > 0 ? '#ef4444' : '#22c55e' },
        ].map(s => (
          <div key={s.label} style={{ background:'#1e293b', borderRadius:12, padding:16, border:'1px solid #334155' }}>
            <div style={{ color:'#64748b', fontSize:12, marginBottom:6 }}>{s.label}</div>
            <div style={{ color:s.color, fontSize:22, fontWeight:800 }}>{s.value}</div>
          </div>
        ))}
      </div>

      {loading ? (
        <div style={{ color:'#64748b', textAlign:'center', padding:40 }}>Cargando...</div>
      ) : datos.length === 0 ? (
        <div style={{ color:'#64748b', textAlign:'center', padding:40 }}>Sin registros para {fecha}</div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {datos.map((d: any, i: number) => {
            const cobrador = d.cobrador;
            const nombre = cobrador ? `${cobrador.nombre} ${cobrador.apellido}` : 'Sin nombre';
            const key = d.cobradorId || String(i);
            const isOpen = expandido === key;
            const sistema = d.sistema || {};
            const arqueo = d.arqueo;
            const dif = arqueo ? Number(arqueo.diferencia) : null;
            return (
              <div key={key} style={{ background:'#1e293b', borderRadius:12, border:'1px solid #334155', overflow:'hidden' }}>
                <div onClick={() => setExpandido(isOpen ? null : key)}
                  style={{ padding:'14px 20px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                    <div style={{ width:36, height:36, borderRadius:'50%', background:'#0ea5e922', display:'flex', alignItems:'center', justifyContent:'center', color:'#38bdf8', fontWeight:800, fontSize:14 }}>
                      {nombre.charAt(0)}
                    </div>
                    <div>
                      <div style={{ color:'#f1f5f9', fontWeight:700 }}>{nombre}</div>
                      <div style={{ color:'#64748b', fontSize:12 }}>
                        Recaudado: <span style={{ color:'#22c55e', fontWeight:600 }}>S/. {(d.totalSistema || 0).toFixed(2)}</span>
                        {' · '}Gastos: <span style={{ color:'#f59e0b', fontWeight:600 }}>S/. {(d.totalGastos || 0).toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                  <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                    {arqueo ? chipDif(dif!) : (
                      <span style={{ fontSize:11, color:'#64748b', background:'#64748b22', border:'1px solid #64748b', borderRadius:20, padding:'2px 8px' }}>Sin cerrar</span>
                    )}
                    <span style={{ color:'#64748b', fontSize:18 }}>{isOpen ? '▲' : '▼'}</span>
                  </div>
                </div>
                {isOpen && (
                  <div style={{ padding:'0 20px 20px', borderTop:'1px solid #0f172a' }}>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginTop:16 }}>
                      <div style={{ background:'#0f172a', borderRadius:8, padding:14 }}>
                        <div style={{ color:'#38bdf8', fontWeight:700, marginBottom:10, fontSize:13 }}>Sistema (registrado)</div>
                        {[['Efectivo', sistema.efectivo], ['Yape', sistema.yape], ['Plin', sistema.plin], ['Transferencia', sistema.transferencia]].map(([m, v]) => (
                          <div key={String(m)} style={{ display:'flex', justifyContent:'space-between', marginBottom:6 }}>
                            <span style={{ color:'#94a3b8', fontSize:13 }}>{m}</span>
                            <span style={{ color:'#f1f5f9', fontSize:13 }}>S/. {Number(v || 0).toFixed(2)}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ background:'#0f172a', borderRadius:8, padding:14 }}>
                        <div style={{ color:'#22c55e', fontWeight:700, marginBottom:10, fontSize:13 }}>
                          {arqueo ? 'Declarado por cobrador' : 'Sin cierre de caja'}
                        </div>
                        {arqueo ? [
                          ['Efectivo', arqueo.efectivoDeclarado], ['Yape', arqueo.yapeDeclarado],
                          ['Plin', arqueo.plinDeclarado], ['Transferencia', arqueo.transferenciaDeclarado],
                        ].map(([m, v]) => (
                          <div key={String(m)} style={{ display:'flex', justifyContent:'space-between', marginBottom:6 }}>
                            <span style={{ color:'#94a3b8', fontSize:13 }}>{m}</span>
                            <span style={{ color:'#f1f5f9', fontSize:13 }}>S/. {Number(v || 0).toFixed(2)}</span>
                          </div>
                        )) : <div style={{ color:'#64748b', fontSize:13 }}>El cobrador aun no cerro caja.</div>}
                        {arqueo?.notas && <div style={{ marginTop:8, color:'#94a3b8', fontSize:12, fontStyle:'italic' }}>Notas: {arqueo.notas}</div>}
                      </div>
                    </div>
                    {d.gastos && d.gastos.length > 0 && (
                      <div style={{ marginTop:14, background:'#0f172a', borderRadius:8, padding:14 }}>
                        <div style={{ color:'#f59e0b', fontWeight:700, marginBottom:10, fontSize:13 }}>Gastos ({d.gastos.length})</div>
                        {d.gastos.map((g: any) => (
                          <div key={g.id} style={{ display:'flex', justifyContent:'space-between', marginBottom:6 }}>
                            <span style={{ color:'#94a3b8', fontSize:13 }}>{g.concepto}</span>
                            <span style={{ color:'#f59e0b', fontSize:13 }}>S/. {Number(g.monto).toFixed(2)}</span>
                          </div>
                        ))}
                        <div style={{ borderTop:'1px solid #1e293b', marginTop:6, paddingTop:6, display:'flex', justifyContent:'space-between' }}>
                          <span style={{ color:'#64748b', fontSize:13 }}>Total gastos</span>
                          <span style={{ color:'#f59e0b', fontWeight:700, fontSize:13 }}>S/. {(d.totalGastos || 0).toFixed(2)}</span>
                        </div>
                      </div>
                    )}
                    {arqueo && (
                      <div style={{ marginTop:14, background: dif !== null && Math.abs(dif) < 0.01 ? '#22c55e11' : '#ef444411',
                        border:`1px solid ${dif !== null && Math.abs(dif) < 0.01 ? '#22c55e44' : '#ef444444'}`,
                        borderRadius:8, padding:14, textAlign:'center' }}>
                        <div style={{ color:'#94a3b8', fontSize:13, marginBottom:4 }}>
                          Diferencia = declarado + gastos − sistema
                        </div>
                        <div style={{ fontSize:20, fontWeight:800, color: dif !== null && Math.abs(dif) < 0.01 ? '#22c55e' : dif! > 0 ? '#f59e0b' : '#ef4444' }}>
                          {dif !== null && Math.abs(dif) < 0.01 ? 'Caja cuadrada ✓' : `Diferencia: S/. ${dif?.toFixed(2)}`}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

// ── Vista personal: cobrador / técnico cierra su propia caja ─────────────────
const VistaMiCaja: React.FC = () => {
  const [datos, setDatos] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [modalCerrar, setModalCerrar] = useState(false);
  const [modalGasto, setModalGasto] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [formCierre, setFormCierre] = useState({ efectivoDeclarado:'', yapeDeclarado:'', plinDeclarado:'', transferenciaDeclarado:'', notas:'' });
  const [formGasto, setFormGasto] = useState({ concepto:'', monto:'' });

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await api.get('/caja/hoy');
      setDatos(res.data);
    } catch {}
    finally { setLoading(false); }
  };

  useEffect(() => { cargar(); }, []);

  const abrirCerrar = () => {
    const arqueo = datos?.arqueo;
    setFormCierre({
      efectivoDeclarado: arqueo ? String(arqueo.efectivoDeclarado) : '',
      yapeDeclarado: arqueo ? String(arqueo.yapeDeclarado) : '',
      plinDeclarado: arqueo ? String(arqueo.plinDeclarado) : '',
      transferenciaDeclarado: arqueo ? String(arqueo.transferenciaDeclarado) : '',
      notas: arqueo?.notas || '',
    });
    setModalCerrar(true);
  };

  const abrirCaja = async () => {
    try {
      await api.post('/caja/abrir');
      cargar();
    } catch { alert('Error al abrir caja'); }
  };

  const cerrarCaja = async () => {
    setGuardando(true);
    try {
      await api.post('/caja/cerrar', {
        efectivoDeclarado: Number(formCierre.efectivoDeclarado || 0),
        yapeDeclarado: Number(formCierre.yapeDeclarado || 0),
        plinDeclarado: Number(formCierre.plinDeclarado || 0),
        transferenciaDeclarado: Number(formCierre.transferenciaDeclarado || 0),
        notas: formCierre.notas || null,
      });
      setModalCerrar(false);
      cargar();
    } catch { alert('Error al cerrar caja'); }
    finally { setGuardando(false); }
  };

  const registrarGasto = async () => {
    if (!formGasto.concepto || !formGasto.monto) { alert('Completa concepto y monto'); return; }
    setGuardando(true);
    try {
      await api.post('/caja/gastos', { concepto: formGasto.concepto, monto: Number(formGasto.monto) });
      setFormGasto({ concepto:'', monto:'' });
      setModalGasto(false);
      cargar();
    } catch { alert('Error al registrar gasto'); }
    finally { setGuardando(false); }
  };

  const eliminarGasto = async (id: string) => {
    if (!window.confirm('¿Eliminar este gasto?')) return;
    try { await api.delete(`/caja/gastos/${id}`); cargar(); } catch { alert('Error'); }
  };

  if (loading) return <div style={{ color:'#64748b', textAlign:'center', padding:60 }}>Cargando...</div>;

  const sistema = datos?.sistema || {};
  const arqueo = datos?.arqueo;
  const totalDeclarado = arqueo
    ? Number(arqueo.efectivoDeclarado || 0) + Number(arqueo.yapeDeclarado || 0) + Number(arqueo.plinDeclarado || 0) + Number(arqueo.transferenciaDeclarado || 0)
    : 0;
  const dif = arqueo ? Number(arqueo.diferencia) : null;
  const cajaAbierta = !!arqueo?.abierta; // true solo si arqueo existe Y está abierta
  const cajaExiste = !!arqueo; // true si hay registro de arqueo (aunque esté cerrada)

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h2 style={{ color:'#f1f5f9', margin:0, fontSize:24, fontWeight:800 }}>💼 Mi Caja</h2>
          <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>
            {datos?.fecha} · {cajaAbierta
              ? <span style={{ color:'#22c55e' }}>Abierta</span>
              : cajaExiste
                ? <span style={{ color:'#ef4444' }}>Cerrada</span>
                : <span style={{ color:'#f59e0b' }}>Sin abrir</span>}
          </p>
        </div>
        <div style={{ display:'flex', gap:10 }}>
          <button onClick={() => { setFormGasto({ concepto:'', monto:'' }); setModalGasto(true); }}
            style={{ background:'#f59e0b22', border:'1px solid #f59e0b55', color:'#f59e0b', padding:'10px 18px', borderRadius:10, cursor:'pointer', fontWeight:700, fontSize:14 }}>
            + Registrar Gasto
          </button>
          {cajaAbierta ? (
            <button onClick={abrirCerrar}
              style={{ background:'#22c55e', border:'1px solid #22c55e', color:'white', padding:'10px 18px', borderRadius:10, cursor:'pointer', fontWeight:700, fontSize:14 }}>
              🔒 Cerrar Caja
            </button>
          ) : (
            <button onClick={abrirCaja}
              style={{ background:'#0ea5e9', border:'1px solid #0ea5e9', color:'white', padding:'10px 18px', borderRadius:10, cursor:'pointer', fontWeight:700, fontSize:14 }}>
              {cajaExiste ? '🔓 Reabrir Caja' : '🔓 Abrir Caja'}
            </button>
          )}
        </div>
      </div>

      {/* Stats */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:14, marginBottom:24 }}>
        {[
          { label:'Cobrado (sistema)', value:`S/. ${(datos?.totalSistema || 0).toFixed(2)}`, color:'#22c55e' },
          { label:'Gastos del día', value:`S/. ${(datos?.totalGastos || 0).toFixed(2)}`, color:'#f59e0b' },
          { label:'Neto', value:`S/. ${(datos?.neto || 0).toFixed(2)}`, color:'#38bdf8' },
          { label:'Estado', value: cajaAbierta ? 'Abierta' : cajaExiste ? 'Cerrada' : 'Sin abrir', color: cajaAbierta ? '#22c55e' : cajaExiste ? '#ef4444' : '#f59e0b' },
        ].map(s => (
          <div key={s.label} style={{ background:'#1e293b', borderRadius:12, padding:16, border:'1px solid #334155' }}>
            <div style={{ color:'#64748b', fontSize:12, marginBottom:6 }}>{s.label}</div>
            <div style={{ color:s.color, fontSize:20, fontWeight:800 }}>{s.value}</div>
          </div>
        ))}
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:20 }}>
        {/* Desglose sistema */}
        <div style={{ background:'#1e293b', borderRadius:12, padding:20, border:'1px solid #334155' }}>
          <div style={{ color:'#38bdf8', fontWeight:700, marginBottom:14, fontSize:14 }}>📊 Desglose sistema</div>
          {[['Efectivo', sistema.efectivo, '#22c55e'], ['Yape', sistema.yape, '#a78bfa'], ['Plin', sistema.plin, '#34d399'], ['Transferencia', sistema.transferencia, '#38bdf8']].map(([m, v, c]) => (
            <div key={String(m)} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
              <span style={{ color:'#94a3b8', fontSize:14 }}>{m}</span>
              <span style={{ color:String(c), fontWeight:700, fontSize:15 }}>S/. {Number(v || 0).toFixed(2)}</span>
            </div>
          ))}
        </div>

        {/* Arqueo declarado / estado cierre */}
        <div style={{ background:'#1e293b', borderRadius:12, padding:20, border:'1px solid #334155' }}>
          <div style={{ color:'#22c55e', fontWeight:700, marginBottom:14, fontSize:14 }}>
            {cajaAbierta ? '⚠️ Caja abierta' : cajaExiste ? '✅ Declarado al cierre' : '⚠️ Caja sin abrir'}
          </div>
          {cajaExiste ? (
            <>
              {[['Efectivo', arqueo.efectivoDeclarado], ['Yape', arqueo.yapeDeclarado], ['Plin', arqueo.plinDeclarado], ['Transferencia', arqueo.transferenciaDeclarado]].map(([m, v]) => (
                <div key={String(m)} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                  <span style={{ color:'#94a3b8', fontSize:14 }}>{m}</span>
                  <span style={{ color:'#f1f5f9', fontWeight:600 }}>S/. {Number(v || 0).toFixed(2)}</span>
                </div>
              ))}
              <div style={{ borderTop:'1px solid #334155', marginTop:10, paddingTop:10 }}>
                <div style={{ display:'flex', justifyContent:'space-between' }}>
                  <span style={{ color:'#64748b', fontSize:13 }}>Total declarado</span>
                  <span style={{ color:'#f1f5f9', fontWeight:700 }}>S/. {totalDeclarado.toFixed(2)}</span>
                </div>
              </div>
              {arqueo.notas && <div style={{ marginTop:8, color:'#94a3b8', fontSize:12, fontStyle:'italic' }}>"{arqueo.notas}"</div>}
            </>
          ) : (
            <div style={{ color:'#64748b', fontSize:13, marginTop:8 }}>
              {cajaAbierta
                ? 'Tu caja está abierta. Puedes registrar pagos y gastos. Al terminar, usa "Cerrar Caja".'
                : 'No has abierto tu caja hoy. Usa el botón "Abrir Caja" para empezar a cobrar.'}
            </div>
          )}
        </div>
      </div>

      {/* Resultado cierre */}
      {cajaExiste && (
        <div style={{ background: dif !== null && Math.abs(dif) < 0.01 ? '#22c55e11' : dif! > 0 ? '#f59e0b11' : '#ef444411',
          border:`2px solid ${dif !== null && Math.abs(dif) < 0.01 ? '#22c55e55' : dif! > 0 ? '#f59e0b55' : '#ef444455'}`,
          borderRadius:12, padding:20, marginBottom:20, textAlign:'center' }}>
          <div style={{ color:'#64748b', fontSize:13, marginBottom:6 }}>
            Declarado (S/. {totalDeclarado.toFixed(2)}) + Gastos (S/. {(datos?.totalGastos || 0).toFixed(2)}) − Sistema (S/. {(datos?.totalSistema || 0).toFixed(2)})
          </div>
          <div style={{ fontSize:24, fontWeight:800, color: dif !== null && Math.abs(dif) < 0.01 ? '#22c55e' : dif! > 0 ? '#f59e0b' : '#ef4444' }}>
            {dif !== null && Math.abs(dif) < 0.01 ? '✓ Caja cuadrada' : dif! > 0 ? `Sobrante: S/. ${dif?.toFixed(2)}` : `Faltante: S/. ${Math.abs(dif!).toFixed(2)}`}
          </div>
        </div>
      )}

      {/* Gastos del día */}
      <div style={{ background:'#1e293b', borderRadius:12, border:'1px solid #334155', overflow:'hidden' }}>
        <div style={{ padding:'14px 20px', borderBottom:'1px solid #334155', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ color:'#f59e0b', fontWeight:700, fontSize:14 }}>💸 Gastos del día</span>
          <span style={{ color:'#64748b', fontSize:12 }}>{(datos?.gastos || []).length} registros</span>
        </div>
        {(datos?.gastos || []).length === 0 ? (
          <div style={{ color:'#64748b', textAlign:'center', padding:24, fontSize:13 }}>Sin gastos registrados hoy</div>
        ) : (
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ background:'#0f172a' }}>
                {['Concepto', 'Monto', ''].map(h => (
                  <th key={h} style={{ padding:'10px 16px', color:'#64748b', fontSize:12, fontWeight:600, textAlign:'left', borderBottom:'1px solid #334155' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(datos?.gastos || []).map((g: any) => (
                <tr key={g.id} style={{ borderBottom:'1px solid #0f172a' }}>
                  <td style={{ padding:'10px 16px', color:'#f1f5f9' }}>{g.concepto}</td>
                  <td style={{ padding:'10px 16px', color:'#f59e0b', fontWeight:700 }}>S/. {Number(g.monto).toFixed(2)}</td>
                  <td style={{ padding:'10px 16px' }}>
                    <button onClick={() => eliminarGasto(g.id)}
                      style={{ background:'#ef444422', border:'1px solid #ef444444', color:'#ef4444', borderRadius:6, padding:'3px 10px', fontSize:11, cursor:'pointer' }}>
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal cerrar caja */}
      {modalCerrar && (
        <div onClick={() => setModalCerrar(false)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999 }}>
          <div onClick={e => e.stopPropagation()} style={{ background:'#1e293b', borderRadius:16, padding:28, width:440, border:'1px solid #334155' }}>
            <h3 style={{ color:'#f1f5f9', margin:'0 0 6px' }}>🔒 {cajaExiste ? 'Recalcular cierre' : 'Cerrar Caja'}</h3>
            <p style={{ color:'#64748b', fontSize:12, margin:'0 0 20px' }}>Declara cuánto tienes de cada método. Si cuadra con el sistema, la diferencia será cero.</p>

            <div style={{ background:'#0f172a', borderRadius:10, padding:14, marginBottom:16 }}>
              <div style={{ color:'#64748b', fontSize:12, marginBottom:10 }}>Sistema registró:</div>
              {[['Efectivo', sistema.efectivo], ['Yape', sistema.yape], ['Plin', sistema.plin], ['Transferencia', sistema.transferencia]].map(([m, v]) => (
                <div key={String(m)} style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:4 }}>
                  <span style={{ color:'#94a3b8' }}>{m}</span>
                  <span style={{ color:'#22c55e', fontWeight:600 }}>S/. {Number(v || 0).toFixed(2)}</span>
                </div>
              ))}
            </div>

            {[
              { key:'efectivoDeclarado', label:'Efectivo declarado' },
              { key:'yapeDeclarado', label:'Yape declarado' },
              { key:'plinDeclarado', label:'Plin declarado' },
              { key:'transferenciaDeclarado', label:'Transferencia declarada' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom:12 }}>
                <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:4 }}>{f.label}</label>
                <input
                  type="number" step="0.01" min="0"
                  value={(formCierre as any)[f.key]}
                  onChange={e => setFormCierre(prev => ({ ...prev, [f.key]: e.target.value }))}
                  placeholder="0.00"
                  style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 12px', color:'white', fontSize:14, boxSizing:'border-box' }} />
              </div>
            ))}

            <div style={{ marginBottom:16 }}>
              <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:4 }}>Notas (opcional)</label>
              <textarea value={formCierre.notas} onChange={e => setFormCierre(prev => ({ ...prev, notas: e.target.value }))}
                placeholder="Alguna observación..."
                style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 12px', color:'white', fontSize:13, resize:'vertical', minHeight:60, boxSizing:'border-box' }} />
            </div>

            <div style={{ display:'flex', gap:10 }}>
              <button onClick={() => setModalCerrar(false)} style={{ flex:1, background:'#334155', border:'none', color:'#94a3b8', borderRadius:10, padding:12, cursor:'pointer', fontWeight:600 }}>
                Cancelar
              </button>
              <button onClick={cerrarCaja} disabled={guardando}
                style={{ flex:2, background:'#22c55e', border:'none', color:'white', borderRadius:10, padding:12, cursor:'pointer', fontWeight:700, fontSize:15 }}>
                {guardando ? 'Guardando...' : '✓ Confirmar cierre'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal registrar gasto */}
      {modalGasto && (
        <div onClick={() => setModalGasto(false)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999 }}>
          <div onClick={e => e.stopPropagation()} style={{ background:'#1e293b', borderRadius:16, padding:28, width:380, border:'1px solid #334155' }}>
            <h3 style={{ color:'#f1f5f9', margin:'0 0 20px' }}>💸 Registrar Gasto</h3>
            <div style={{ marginBottom:14 }}>
              <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:4 }}>Concepto *</label>
              <input value={formGasto.concepto} onChange={e => setFormGasto(f => ({ ...f, concepto: e.target.value }))}
                placeholder="Ej: Combustible, papelería..."
                style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 12px', color:'white', fontSize:14, boxSizing:'border-box' }} />
            </div>
            <div style={{ marginBottom:20 }}>
              <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:4 }}>Monto S/. *</label>
              <input type="number" step="0.01" min="0" value={formGasto.monto} onChange={e => setFormGasto(f => ({ ...f, monto: e.target.value }))}
                placeholder="0.00"
                style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 12px', color:'white', fontSize:14, boxSizing:'border-box' }} />
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={() => setModalGasto(false)} style={{ flex:1, background:'#334155', border:'none', color:'#94a3b8', borderRadius:10, padding:12, cursor:'pointer', fontWeight:600 }}>
                Cancelar
              </button>
              <button onClick={registrarGasto} disabled={guardando}
                style={{ flex:2, background:'#f59e0b', border:'none', color:'white', borderRadius:10, padding:12, cursor:'pointer', fontWeight:700 }}>
                {guardando ? 'Guardando...' : '+ Registrar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ── Componente principal: admin ve ambas vistas con toggle ────────────────────
const ArqueoCaja: React.FC = () => {
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const esAdmin = ['gerente', 'administrador'].includes(usuario.rol);
  const [vistaAdmin, setVistaAdmin] = React.useState(true);

  if (!esAdmin) return <VistaMiCaja />;

  return (
    <div>
      {/* Toggle de vista para admin */}
      <div style={{ display:'flex', gap:8, marginBottom:20, background:'#0f172a', borderRadius:10, padding:4, width:'fit-content' }}>
        <button onClick={() => setVistaAdmin(true)}
          style={{ background: vistaAdmin ? '#0ea5e9' : 'transparent', border:'none', color: vistaAdmin ? 'white' : '#64748b', borderRadius:8, padding:'8px 20px', cursor:'pointer', fontWeight:700, fontSize:13, transition:'all 0.15s' }}>
          🏦 Vista General
        </button>
        <button onClick={() => setVistaAdmin(false)}
          style={{ background: !vistaAdmin ? '#22c55e' : 'transparent', border:'none', color: !vistaAdmin ? 'white' : '#64748b', borderRadius:8, padding:'8px 20px', cursor:'pointer', fontWeight:700, fontSize:13, transition:'all 0.15s' }}>
          💼 Mi Caja
        </button>
      </div>
      {vistaAdmin ? <VistaAdmin /> : <VistaMiCaja />}
    </div>
  );
};

export default ArqueoCaja;
